import {useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {OFFER_LIST_PAGE_SIZE} from "../../offer/list/constants/offer_list";
import {OfferType} from "../../offer/types/OfferType";
import {Country} from "../../region/types/Country";
import {useGetModularHouseOfferListQuery} from "../api/get_modular_houses_offer_list";
import {getOfferListModularHousesPayload} from "../utils/get_offer_list_modular_houses_payload";

const MODULAR_HOUSE_PER_OFFER_LIST_PAGE = 2;
export const useGetOfferListModularHouses = () => {
    const {page, count, latestQuery} = useSelector((state: IRPStore) => state.offerList.list);
    const {type: offerType = "", country = "1"} = latestQuery ?? {};
    const lastPage = count ? Math.ceil(count / OFFER_LIST_PAGE_SIZE) : 1;
    const isLastPage = page === lastPage;

    const {data: offers} = useGetModularHouseOfferListQuery(
        getOfferListModularHousesPayload({
            page: page,
            regularOffersCount: count
        }),
        {skip: !(offerType === OfferType.HOUSE.toString() && country === Country.POLAND.toString())}
    );

    const modularOffersCount = offers?.count;
    const showRestModularHouses = modularOffersCount && isLastPage && modularOffersCount > page * MODULAR_HOUSE_PER_OFFER_LIST_PAGE;

    const {data: restOffers} = useGetModularHouseOfferListQuery(
        getOfferListModularHousesPayload({
            page: page,
            regularOffersCount: count,
            isLastPage: isLastPage,
            modularHousesOffersCount: modularOffersCount
        }),
        {skip: !showRestModularHouses}
    );

    const modularHousesExist = offers?.results && offers.results.length > 0;

    const modularHouseOffers = modularHousesExist ? offers : undefined;
    const modularHouseOffersRest = modularHousesExist ? restOffers : undefined;

    return {modularHouseOffers, modularHouseOffersRest};
};
import {useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {OFFER_LIST_PAGE_SIZE} from "../../offer/list/constants/offer_list";
import {OfferType} from "../../offer/types/OfferType";
import {Country} from "../../region/types/Country";
import {useGetModularHouseOfferListQuery} from "../api/get_modular_houses_offer_list";
import {getOfferListModularHousesPayload} from "../utils/get_offer_list_modular_houses_payload";

const MODULAR_HOUSE_PER_OFFER_LIST_PAGE = 2;
export const useGetOfferListModularHouses = () => {
    const {page, count, latestQuery} = useSelector((state: IRPStore) => state.offerList.list);
    const {type: offerType = "", country = "1"} = latestQuery ?? {};
    const lastPage = count ? Math.ceil(count / OFFER_LIST_PAGE_SIZE) : 1;
    const isLastPage = page === lastPage;

    const {data: offers} = useGetModularHouseOfferListQuery(
        getOfferListModularHousesPayload({
            page: page,
            regularOffersCount: count
        }),
        {skip: !(offerType === OfferType.HOUSE.toString() && country === Country.POLAND.toString())}
    );

    const modularOffersCount = offers?.count;
    const showRestModularHouses = modularOffersCount && isLastPage && modularOffersCount > page * MODULAR_HOUSE_PER_OFFER_LIST_PAGE;

    const {data: restOffers} = useGetModularHouseOfferListQuery(
        getOfferListModularHousesPayload({
            page: page,
            regularOffersCount: count,
            isLastPage: isLastPage,
            modularHousesOffersCount: modularOffersCount
        }),
        {skip: !showRestModularHouses}
    );

    const modularHousesExist = offers?.results && offers.results.length > 0;

    const modularHouseOffers = modularHousesExist ? offers : undefined;
    const modularHouseOffersRest = modularHousesExist ? restOffers : undefined;

    return {modularHouseOffers, modularHouseOffersRest};
};
